import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { DocumentTemplateHeaderQuery } from 'generated/resources/graphql'

export type DocumentTemplate = DocumentTemplateHeaderQuery['documents']['template']

interface Props {
  documentTemplate: DocumentTemplate
}

const DetailsPageHeader = ({ documentTemplate }: Props) => {
  if (!documentTemplate) return null

  return <ResourceHeader title={documentTemplate.name} />
}

export default DetailsPageHeader
